// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// 路由
import router from './router/router.js'
// vueX
import store from './store/store'
// element
import ElementUI from 'element-ui'
import './assets/elementUi/theme/index.css'
// 注册自定义命令
import directives from '@/utils/directives'
import * as filters from '@/filters'
import CheckPermission from '@/mixin/checkPermission'
// 引入md5
import md5 from 'js-md5'
// 引入axios拦截器
// eslint-disable-next-line import/no-duplicates
import axios from './config/axios'
// eslint-disable-next-line import/no-duplicates
import instance from './config/axios'
import App from './App'
import Components from '@/components'
import '@/permission' // permission control
// CryptoJS加密
// import secret from '@/components/secret.js'
// 引导页
// import {guide} from '@/utils/intro.js'

// 注册到vue原型上
Vue.prototype.$md5 = md5
Vue.prototype.$service = axios
Vue.prototype.$instance = instance
// Vue.prototype.$secret = secret
// Vue.prototype.$guide = guide

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(directives)
Vue.use(Components)
// Vue.use(window['vue-cropper'].default)
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]) // 注册自定义过滤器
})
// 全局混入检查对象 所有的组件都拥有了检查的方法
Vue.mixin(CheckPermission)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store,
  axios
})



// WEBPACK FOOTER //
// ./src/main.js